import { render, staticRenderFns } from "./CompanyDomain.vue?vue&type=template&id=16ce2812"
import script from "./CompanyDomain.vue?vue&type=script&lang=js"
export * from "./CompanyDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports